<template>
    <div>
        <div style="font-weight: bold;font-size: 18px;">合约争霸比赛管理</div>
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item label="比赛名字">
                <el-input v-model="queryCondition.name"></el-input>
            </el-form-item>
            <el-form-item label="活动code">
                <el-input v-model="queryCondition.code"></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker v-model="datePicker" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="query(1)">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="showEdit=true">创建</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="listInfo">
            <el-table-column label="比赛ID" prop="id"></el-table-column>
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column label="活动码" prop="code"></el-table-column>
            <el-table-column label="奖励总额" prop="bonus"></el-table-column>
            <el-table-column label="招募队长开始时间" prop="recruitTime">
                <template slot-scope="scope">{{parseDateTime(scope.row.recruitTime)}}</template>
            </el-table-column>
            <el-table-column label="组队开始时间" prop="teamTime">
                <template slot-scope="scope">{{parseDateTime(scope.row.teamTime)}}</template>
            </el-table-column>
            <el-table-column label="开始比赛时间" prop="beginTime">
                <template slot-scope="scope">{{parseDateTime(scope.row.beginTime)}}</template>
            </el-table-column>
            <el-table-column label="比赛结束时间" prop="endTime">
                <template slot-scope="scope">{{parseDateTime(scope.row.endTime)}}</template>
            </el-table-column>
            <el-table-column label="人气基础值" prop="popularity"></el-table-column>
            <el-table-column label="队长KOL返佣比例" prop="kolRate"></el-table-column>
            <el-table-column label="创建时间" prop="createdTime">
                <template slot-scope="scope">{{parseDateTime(scope.row.createdTime)}}</template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="queryDetail(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="totalCount" :page-size="10" :current-page="queryCondition.page"
                       @current-change="query"></el-pagination>

        <el-dialog title="合约争霸新增" :visible.sync= "showEdit" @close="closeDialog">
            <el-form label-width="150px" :model="contractInfo" ref="contractForm" label-position="top">
                <el-form-item label="比赛名称" prop="name" :rules="[{ required: true, message: '比赛名称不能为空',trigger: 'blur'}]">
                    <el-input v-model="contractInfo.name" :disabled="ableEdit()"></el-input>
                </el-form-item>
                <el-form-item label="活动码" prop="code" :rules="[{ required: true, message: '活动码不能为空',trigger: 'blur'}]">
                    <el-input v-model="contractInfo.code" :disabled = "codeAbleWrite()"></el-input>
                </el-form-item>
                <el-form-item label="人气基础值（战队排行榜人气增加的基础值）：仅支持正整数 1 - 100" prop="popularity" :rules="[{ required: true, message: '人气基础值不能为空',trigger: 'blur'}]">
                    <el-input v-model="contractInfo.popularity" :disabled="ableEdit()"></el-input>
                </el-form-item>
                <el-form-item label="奖金总额（USDT）" prop="bonus" :rules="[{ required: true, message: '奖金总额不能为空',trigger: 'blur'}]">
                    <el-input v-model="contractInfo.bonus" :disabled="ableEdit()"></el-input>
                </el-form-item>
                <el-form-item label="队长KOL奖励返佣比例（%）：仅支持正整数 1 - 100" prop="kolRate" :rules="[{ required: true, message: '队长KOL奖励返佣比例不能为空',trigger: 'blur'}]">
                    <el-input v-model="contractInfo.kolRate" :disabled="ableEdit()"></el-input>
                </el-form-item>
                <el-form-item label="比赛招募队长开始时间" prop="recruitTime" :rules="[{ required: true, message: '比赛招募队长开始时间不能为空',trigger: 'blur'}]">
                    <el-date-picker v-model="contractInfo.recruitTime" type="datetime" placeholder="选择日期时间" :disabled="ableEdit()"></el-date-picker>
                </el-form-item>
                <el-form-item label="组队开始时间" prop="teamTime" :rules="[{ required: true, message: '组队开始时间不能为空',trigger: 'blur'}]">
                    <el-date-picker v-model="contractInfo.teamTime" type="datetime" placeholder="选择日期时间" :disabled="ableEdit()"></el-date-picker>
                </el-form-item>
                <el-form-item label="开始比赛时间" prop="beginTime" :rules="[{ required: true, message: '开始比赛时间不能为空',trigger: 'blur'}]">
                    <el-date-picker v-model="contractInfo.beginTime" type="datetime" placeholder="选择日期时间" :disabled="ableEdit()"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束比赛时间" prop="endTime" :rules="[{ required: true, message: '结束比赛时间不能为空',trigger: 'blur'}]">
                    <el-date-picker v-model="contractInfo.endTime" type="datetime" placeholder="选择日期时间" :disabled="ableEdit()"></el-date-picker>
                </el-form-item>
                <el-form-item label="战队队员每人每天贡献盈利USDT上限：仅支持正数 1 - 9999" prop="profitLimit" :rules="[{ required: true, message: '战队队员每人每天贡献盈利USDT上限不能为空',trigger: 'blur'}]">
                    <el-input v-model="contractInfo.profitLimit" :disabled="ableEdit()"></el-input>
                </el-form-item>
                <el-form-item label="组队邀请海报(中文)" prop="teamInvitationPosterCn" :rules="[{ required: true, message: '组队邀请海报不能为空',trigger: 'blur'}]">
                    <upload v-model="contractInfo.teamInvitationPosterCn" :data="{language: 1, platform: 1}"></upload>
                </el-form-item>
                <el-form-item label="组队邀请海报(英文)" prop="teamInvitationPosterEn" :rules="[{ required: true, message: '组队邀请海报不能为空',trigger: 'blur'}]">
                    <upload v-model="contractInfo.teamInvitationPosterEn" :data="{language: 1, platform: 1}"></upload>
                </el-form-item>
                <el-form-item label="分享邀请海报（中文）" prop="shareInvitationPosterCn" :rules="[{ required: true, message: '分享邀请海报不能为空',trigger: 'blur'}]">
                    <upload v-model="contractInfo.shareInvitationPosterCn" :data="{language: 1, platform: 1}"></upload>
                </el-form-item>
                <el-form-item label="分享邀请海报（英文）" prop="shareInvitationPosterEn" :rules="[{ required: true, message: '分享邀请海报不能为空',trigger: 'blur'}]">
                    <upload v-model="contractInfo.shareInvitationPosterEn" :data="{language: 1, platform: 1}"></upload>
                </el-form-item>
                <el-form-item label="分享活动海报（中文）" prop="shareActivityPosterCn" :rules="[{ required: true, message: '分享活动海报不能为空',trigger: 'blur'}]">
                    <upload v-model="contractInfo.shareActivityPosterCn" :data="{language: 1, platform: 1}"></upload>
                </el-form-item>
                <el-form-item label="分享活动海报（英文）" prop="shareActivityPosterEn" :rules="[{ required: true, message: '分享活动海报不能为空',trigger: 'blur'}]">
                    <upload v-model="contractInfo.shareActivityPosterEn" :data="{language: 1, platform: 1}"></upload>
                </el-form-item>
                <el-form-item style="text-align: center">
                    <el-button type="info" @click="closeDialog()">取消</el-button>
                    <el-button type="primary" @click="saveConf()">确认</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';
    import upload from '../../components/upload';
    import {mapActions, mapState} from 'vuex';
    export default {
        name: "match",
        components:{upload},
        data(){
            return {
                queryCondition:{
                    name:'',
                    code:'',
                    from:'',
                    to:'',
                    page:1,
                },
                activeName:'',
                datePicker:[],
                dateGame:[],
                showEdit:false,
                contractInfo:{
                    name:'',
                    popularity:'',
                    bonus:'',
                    code:'',
                    kolRate:'',
                    recruitTime:'',
                    teamTime:'',
                    beginTime:'',
                    endTime:'',
                    profitLimit:'',
                    teamInvitationPosterCn:'',
                    teamInvitationPosterEn:'',
                    shareInvitationPosterCn:'',
                    shareInvitationPosterEn:'',
                    shareActivityPosterCn:'',
                    shareActivityPosterEn:'',
                },
                opType:'',
            }
        },
        computed : {...mapState('contractActivity',['totalCount','listInfo'])},
        created(){
            this.query(1);
        },
        methods:{
            ...mapActions('contractActivity',['queryLists']),
            query(val){
                this.queryCondition.page = val;
                this.queryLists(this.queryCondition);
            },
            closeDialog(){
                this.contractInfo = {};
                this.opType = '';
                this.showEdit = false;
            },
            saveConf(){
                this.$refs['contractForm'].validate(valid => {
                    if (valid) {

                        //时间验证
                        if (this.contractInfo.teamTime - this.contractInfo.recruitTime < 6 * 60 * 60 * 1000 )  {
                            this.$message.error('组队开始时间必须大于比赛招募队长开始时间6小时');
                            return;
                        }
                        if (this.contractInfo.beginTime - this.contractInfo.teamTime < 6 * 60 * 60 * 1000 ) {
                            this.$message.error('开始比赛时间必须大于组队开始时间6小时');
                            return;
                        }
                        if (this.contractInfo.endTime - this.contractInfo.beginTime < 6 * 60 * 60 * 1000 ) {
                            this.$message.error('结束比赛时间必须大于开始比赛时间6小时');
                            return;
                        }

                        if (this.opType) {
                            api.updateMatch(this.contractInfo).then(response => {
                                this.$message.success('修改成功');
                                this.showEdit = false;
                            })
                        }else {
                            if (this.contractInfo.recruitTime - new Date().getTime() < 10 * 60 * 1000) {
                                this.$message.error('招募开始时间必须在当前10分钟之后');
                                return;
                            }
                            api.create(this.contractInfo).then(response => {
                                this.$message.success('新增成功');
                                this.query(1);
                                this.showEdit = false;
                            })
                        }
                    }
                })
            },
            parseDateTime(time){
                let now = new Date(time);
                let year=now.getFullYear();
                let month=now.getMonth()+1;
                let date=now.getDate();
                let hour=now.getHours();
                let minute=now.getMinutes();
                let second=now.getSeconds();
                return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
            },
            queryDetail(info){
                this.contractInfo = info;
                this.opType = 'update';
                console.log(info);
                console.log(this.contractInfo);
                this.showEdit = true;
            },
            codeAbleWrite(){
                if (this.contractInfo.recruitTime){
                    return this.contractInfo.recruitTime - new Date().getTime() < 10 * 60 * 1000 * 1000;
                }
                return false;
            },
            ableEdit(){
                if (this.opType) {
                    return this.contractInfo.recruitTime - new Date().getTime() < 0;
                }
                return false;
            }
        }
    }
</script>

<style scoped>

</style>